var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"copy-to-clipboard-button",class:{copied: _vm.copied},attrs:{"rounded":""},on:{"click":_vm.copyToClipboard}})}
var staticRenderFns = []

export { render, staticRenderFns }